import Chip from '@material-ui/core/Chip';
import styles from './styles';
import Avatar from '@material-ui/core/Avatar';
import React from 'react';

const StageChip = ({ stage, order }) => {
  return (<Chip
    color="secondary"
    style={styles.chip}
    label={stage.name}
    clickable
    avatar={<Avatar size={32}>{order}</Avatar>}
  />);
};

export default StageChip;



// WEBPACK FOOTER //
// ./src/components/Admin/JobProfiles/JobProfilesGrid/StageChip.js